import { AppBarTitle } from '@components/app-bar-title';

import { IconButton } from '@material-ui/core';

import AdvancedC3PageRelationSearch from './c3-search';
import { SearchIcon } from '@material-ui/data-grid';

export default function C3PageSearch() {
  return (
    <>
      <AppBarTitle>
        <IconButton color="inherit">
          <SearchIcon />
        </IconButton>{' '}
        C3 Page - Content to Person Relations Search
      </AppBarTitle>

      <AdvancedC3PageRelationSearch />
    </>
  );
}
